import { NgModule } from '@angular/core';
import { DatastoreDomainsModule } from '@freelancer/datastore/collections';
import { MODALS } from '@freelancer/ui/modal';

@NgModule({
  imports: [DatastoreDomainsModule],
  providers: [
    {
      provide: MODALS,
      useValue: () =>
        import('./language-switcher-modal-routes').then(
          m => m.languageSwitcherModals,
        ),
      multi: true,
    },
  ],
})
export class LanguageSwitcherModalsModule {}
